import React from 'react';
import logo from './man_and_guitar.svg';

const imgStyle = {
  margin: '4px'
};

const Header = () => (
  <header className="row">
    <div className="col-md-5">
      <img style={imgStyle} src={logo} className="logo" alt="logo" />
    </div>
    <div className="col-md-7 mt-5 subtitle">Vintage Guitar World</div>
  </header>
);

export default Header;



// WEBPACK FOOTER //
// ./src/main-page/header.js